import React, { useState, useEffect, useMemo } from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls"
import TimeFrameDateSelector from "components/TimeFrameDateSelector"
import LoaderAnimation from "pages/LoaderAnimation";

import moment from "moment";

function Contracts(props) {
  const [employeeHours, setEmployeeHours] = useState([]);
  const [hourTypes, setHourTypes] = useState([]);

  const [isViewEnabled, setIsViewEnabled] = useState(true);
  const [hasLoadedData, setHasLoadedData] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);

  const loadContracts = (time, startDate, endDate) => {
    setIsViewEnabled(false);
    setIsLoadingData(true);
    setHasLoadedData(true);

    apiGet(apiUrls.getEmployeeContractHours(props.employeeId, startDate, endDate)).then((response) => {
      console.log(response.data);

      let eeHrs = response.data;
      let hrTypes = [];
      for(let i = 0; i < eeHrs.length; i++) {
        for(let j = 0; j < eeHrs[i].employeeHours.length; j++) {
          if (hrTypes.findIndex(h => h.typeOfHoursID === eeHrs[i].employeeHours[j].typeOfHoursID) === -1) {
            hrTypes.push({ typeOfHoursID: eeHrs[i].employeeHours[j].typeOfHoursID, typeOfHoursName: eeHrs[i].employeeHours[j].typeOfHoursName });
          }
        }
      }
      hrTypes.sort((a, b) => a.typeOfHoursID - b.typeOfHoursID);
      console.log(hrTypes);

      setHourTypes(hrTypes);
      setEmployeeHours(response.data);

      setIsViewEnabled(true);
      setHasLoadedData(true);
      setIsLoadingData(false);
    });
  }

  return (
        <Box className="container-fluid">
            <Box className="d-flex justify-content-end align-items-center mb-2">
                <TimeFrameDateSelector payPeriodsUrl={apiUrls.getHWPayPeriods(props.companyId)}
                                       handleView={loadContracts}
                                       isViewEnabled={isViewEnabled} />
            </Box>
            <Box>
                {hasLoadedData ?
                    isLoadingData ? 
                        <LoaderAnimation /> :
                        
                      <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Contract Code</TableCell>
                            <TableCell>Pay Date</TableCell>
                            <TableCell>Start Date</TableCell>
                            <TableCell>End Date</TableCell>
                            {hourTypes.length > 0 ? 
                              hourTypes.map(hourType => (
                                <TableCell>{hourType.typeOfHoursName}</TableCell>
                              )) : null}
                            <TableCell>Total Hours</TableCell>
                            <TableCell>Fringe Rate</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {employeeHours.map((row) => (
                            <TableRow key={row.payDate}>
                              <TableCell component="th" scope="row">
                                {row.contractCodeCode}
                              </TableCell>
                              <TableCell>{moment(row.payDate).calendar()}</TableCell>
                              <TableCell>{moment(row.workStart).calendar()}</TableCell>
                              <TableCell>{moment(row.workEnd).calendar()}</TableCell>
                              {hourTypes.length > 0 ? 
                                hourTypes.map(hourType => {
                                  let matchingIndex = row.employeeHours.findIndex(eh => eh.typeOfHoursName == hourType.typeOfHoursName);

                                  return (
                                    <TableCell>{matchingIndex > -1 ? row.employeeHours[matchingIndex].hours.toFixed(4) : '0.0000'}</TableCell>
                                  )
                                }) : null}
                              <TableCell>{row.totalHours.toFixed(4)}</TableCell>
                              <TableCell>{row.fringeRate.toFixed(4)}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    : null}
            </Box>
        </Box>
  );
}

export default Contracts;
